const idOf = value => {
  if (value && value._id) return String(value._id);
  if (value == null || value === '') return '';
  return String(value);
};

export const packagesForProperty = (packages, propertyUnitIds) => {
  const unitIds =
    propertyUnitIds instanceof Set
      ? propertyUnitIds
      : new Set((propertyUnitIds || []).map(idOf).filter(Boolean));
  return (packages || []).filter(pkg => (pkg.units || []).some(uid => unitIds.has(idOf(uid))));
};

export const unitsForPackage = (units, pkg) => {
  if (!pkg) return units || [];
  const packageUnitIds = new Set((pkg.units || []).map(idOf).filter(Boolean));
  return (units || []).filter(unit => packageUnitIds.has(idOf(unit && unit._id)));
};

export const findPackageById = (packages, packageId) => {
  if (!packageId) return null;
  const id = String(packageId);
  return (packages || []).find(pkg => String(pkg._id) === id) || null;
};

const ownerIdOfUnit = unit => {
  const ownedBy = unit && unit.ownedBy;
  if (ownedBy == null || ownedBy === '') return '';
  if (typeof ownedBy === 'object') return String(ownedBy._id || ownedBy.id || '');
  return String(ownedBy);
};

export const unitsOwnedBy = (units, ownerId) => {
  if (!ownerId) return [];
  const id = String(ownerId);
  return (units || []).filter(unit => ownerIdOfUnit(unit) === id);
};
